module.exports = `${require.publicPath}home-img05.4aacf833.png`;